<span class="tag carryover"
  ><img src="assets/images/icons/svg/carryover_moon-filled.svg" alt="icon" class="icon" />
  {{ count }} Carryover{{ count > 1 ? 's' : '' }}</span
>
